var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"fill-height justify-center loading"},[_c('v-progress-circular',{class:{'mb-10': _vm.bottomMargin},attrs:{"size":_vm.size,"width":2,"color":_vm.color,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }